// in memory location of access token
let accessToken = null;

export const getAccessToken = () => accessToken;

export const setAccessToken = token => {
  accessToken = token;
};

export const clearAccessToken = () => {
  accessToken = null;
};
